var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10107 7.78449H17.1175M10.1093 7.78449V16.3501M5.59288 16.3501H14.6257C15.4979 16.3501 15.934 16.3501 16.2671 16.1803C16.5602 16.031 16.7984 15.7928 16.9477 15.4997C17.1175 15.1666 17.1175 14.7305 17.1175 13.8583V6.38286C17.1175 5.51065 17.1175 5.07453 16.9477 4.7414C16.7984 4.44835 16.5602 4.2101 16.2671 4.0608C15.934 3.89105 15.4979 3.89105 14.6257 3.89105H5.59288C4.72067 3.89105 4.28456 3.89105 3.95142 4.0608C3.65837 4.2101 3.42013 4.44835 3.27082 4.7414C3.10107 5.07453 3.10107 5.51064 3.10107 6.38286V13.8583C3.10107 14.7305 3.10107 15.1666 3.27082 15.4997C3.42013 15.7928 3.65837 16.031 3.95142 16.1803C4.28456 16.3501 4.72066 16.3501 5.59288 16.3501Z",
    stroke: "#E5E5E5",
    strokeWidth: 2.0765,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStations);
export default __webpack_public_path__ + "static/media/stations.2be259b30ad15d8599efbec739df13f9.svg";
export { ForwardRef as ReactComponent };